<template>
    <div>
        <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="pricing_options">Pricing</h2>

        <!-- single pricing option -->
        <div v-if="activeOptions.length === 1"
            class="flex w-full justify-center">

            <proposal-pricing-option
                v-model="localValue"
                :data="activeOptions[0]"
                :selectable="false"
            />
        </div>

        <!-- multiple pricing options -->
        <div v-else class="flex flex-col justify-between gap-y-8 items-center lg:flex-row lg:flex-wrap lg:gap-x-8 mt-4">
            <proposal-pricing-option
                v-for="option in activeOptions"
                :key="option.number"
                v-model="localValue"
                :data="option"
                :recommended="option.number === 2"
            />
        </div>
    </div>
</template>

<script>
import ProposalPricingOption from "./proposal-31-pricing-option";

export default {
    components: {
        ProposalPricingOption,
    },
    props: {
        value: {
			type: Number,
			required: true
		},
        data: {
			type: Object,
			required: true
		},
    },
    data() {
        return {
            localValue: this.value
        }
    },
    computed: {
        activeOptions() {
            return [1, 2, 3, 4]
                .map((number) => this.data['pricing_option' + number])
                .filter((option) => option && option.is_active);
        },
    },
    watch: {
        value(newValue) {
            this.setLocalValue(newValue);
        },
        localValue(newValue) {
            this.updateValue(newValue);
        },
    },
    methods: {
        setLocalValue(newValue) {
            this.localValue = newValue;
        },
        updateValue(newValue) {
            this.$emit('input', newValue);
        },
    }
}
</script>